<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('Profile|Personal Labels') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  'Profile|Personal labels allow you to organize tasks across all your projects using your own custom labels. These labels are visible only to you and help you categorize tasks according to your personal workflow.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|How It Works') }}</h4>
            <p>
              {{
                s__(
                  'Profile|Once enabled, you can create personal labels in your profile settings. These labels can then be applied to tasks in any project you have access to, regardless of project-specific labels.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|Use Cases') }}</h4>
            <p>
              {{
                s__(
                  'Profile|Personal labels are useful for organizing tasks by your own priorities, work types, or personal categories. For example, you might create labels like "Urgent", "Learning", "Review", or "Follow-up" that apply across all your projects.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|Privacy') }}</h4>
            <p>
              {{
                s__(
                  'Profile|Personal labels are private to you. Other project members cannot see your personal labels, and you cannot see theirs. This allows each team member to organize tasks according to their own preferences.'
                )
              }}
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('Profile|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}
</style>
